export default "__VITE_ASSET__Cqcp1oif__";